<template>
  <div class="guide-module">
    <div class="avatar-box">
      <img class="avatar" src="https://o.666visa.cn/static/ssqpeer/chatvisa/icon-avatar.png" alt="">
    </div>
    <div class="header-box">
      <div class="header-title">我是「签问」，你的签证 AI 助手</div>
      <div v-if="showClose" class="icon-close" @click="onClose"></div>
    </div>
    <div class="subtitle">
      <div class="subtitle-text">作为你的智能伙伴，我可以帮你做这些事：</div>
      <div v-if="has_more" class="change-btn" @click="getQuestionList(true)">
        <div class="icon"></div>
        换一换
      </div>
    </div>
    <div class="question-list">
      <div class="question-item" v-for="(item, index) in questionList" :key="index">
        <div class="question-item-body" @click="clickQuestion(item)">
          <div class="item-title">{{ item.title }}</div>
          <div class="item-content">{{ item.content }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http from '@/libs/http';
import User from '@/libs/user';
import { mapMutations } from 'vuex';
import sensorsdata from 'sa-sdk-javascript';

export default {
  components: {},
  props: {
    showClose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      has_more: false,
      questionList: [],
    };
  },
  computed: {},
  created() {
    this.getQuestionList();
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    async getQuestionList(isChange) {
      const params = {};
      if (isChange && this.questionList.length) {
        params.last_pos = this.questionList[this.questionList.length - 1].pos;
      }
      const res = await Http.post('/sys/visa_chat_question_brief_query', params);
      this.questionList = res.page_data;
      this.has_more = res.has_more;
    },
    clickQuestion(item) {
      sensorsdata.track('qw_prompt_click', {});
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX();
        return;
      }
      Http.post('/visa_chat_question_click', { visa_chat_question_id: item.visa_chat_question_id });
      this.$emit('send-question', item.content);
    },
    onClose() {
      sensorsdata.track('qw_guide_close', {});
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.guide-module{
  background: #fff;
  box-shadow: 0px 3px 16px 0px rgba(30,43,61,0.12);
  width: 100%;
  padding: 24px;
  margin: 16px 0 24px 0;
  position: relative;
  border-radius: 8px;
  .avatar-box{
    position: absolute;
    right: 100%;
    margin-top: 12px;
    margin-right: 12px;
    top: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(224deg, #8765FF 0%, #6FACFF 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    .avatar{
      width: 23px;
      height: 23px;
    }
  }
  .header-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header-title{
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
      color: #2F333D;
    }
    .icon-close{
      width: 16px;
      height: 16px;
      background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-close.png) no-repeat center / 100% 100%;
      cursor: pointer;
    }
    
  }
  .subtitle{
    margin-top: 4px;
    font-size: 14px;
    line-height: 20px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #5F666E;
    .change-btn{
      display: flex;
      align-items: center;
      cursor: pointer;
      color: #599FFF;
      .icon{
        width: 16px;
        height: 16px;
        margin-right: 3px;
        background: url(https://o.666visa.cn/static/ssqpeer/chatvisa/icon-change.png) no-repeat center / 100% 100%;
      }
    }
  }
  .question-list{
    margin-top: 16px;
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
    margin-bottom: -16px;
    .question-item{
      width: 50%;
      padding: 0 8px;
      margin-bottom: 16px;
      .question-item-body{
        border-radius: 4px;
        padding: 16px;
        cursor: pointer;
        background: #F6F8FE;
        .item-title{
          font-size: 16px;
          line-height: 22px;
          font-weight: 600;
        }
        .item-content{
          margin-top: 4px;
          font-size: 14px;
          color: #5F666E;
          line-height: 20px;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/chat-visa/components/guide-module.vue